import { PageHero, CtaSection } from "../components/Sections";
import Seo from "../components/Seo";
import { INDUSTRIES, IMAGES, PAGE_SEO } from "../lib/data";

export default function Industries() {
  return (
    <>
      <Seo {...PAGE_SEO.industries} />
      <PageHero
        crumb="Industries"
        image={IMAGES.industries}
        eyebrow="Industries We Serve"
        title="Built for the operations that keep"
        accent="supply chains moving"
        sub="We work specifically with the warehouse types where supply chain complexity meets real operational pressure — and where the right systems work makes the biggest difference."
      />

      <section id="industries">
        <div className="s-inner">
          <div className="ind-grid">
            {INDUSTRIES.map((ind, i) => (
              <div className={`ind-card fade-up ${i ? "d" + i : ""}`} key={ind.title}>
                <div className="ind-icon">{ind.icon}</div>
                <h3>{ind.title}</h3>
                <ul className="ind-pains">
                  {ind.pains.map((p) => <li key={p}>{p}</li>)}
                </ul>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* SHIPPERS / ADDITIONAL */}
      <section id="services">
        <div className="s-inner">
          <div className="about-grid">
            <div className="fade-up">
              <span className="s-eye">A Common Thread</span>
              <h2>Different industries, the same underlying challenge</h2>
              <p className="s-lead" style={{ marginBottom: 18 }}>Whether you run a 3PL, a distribution center, an ecommerce fulfillment operation, or a manufacturing warehouse, the pattern is familiar: growth outpaces the systems and processes that once worked just fine.</p>
              <p className="s-lead">We meet each operation where it is — translating between the floor and the systems team to remove friction, recover lost capacity, and create visibility leadership can act on.</p>
            </div>
            <div className="about-visual fade-up d2">
              <div className="about-card">
                <h3>We also support shippers and growing brands.</h3>
                <p>Beyond the four core verticals, we partner with shippers and scaling brands navigating their first WMS, peak-season readiness, or a multi-system integration.</p>
                <div className="exp-tags">
                  <span className="exp-tag hi">3PL</span>
                  <span className="exp-tag hi">Distribution</span>
                  <span className="exp-tag hi">Ecommerce</span>
                  <span className="exp-tag hi">Manufacturing</span>
                  <span className="exp-tag">Shippers</span>
                  <span className="exp-tag">Growing Brands</span>
                </div>
              </div>
              <div className="about-float">
                <strong>Multi</strong>
                <span>Industry experience</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      <CtaSection
        eyebrow="See If We're A Fit"
        title="Not sure where you fit?"
        accent="Let's talk."
        lead="If supply chain complexity is creating operational pressure in your warehouse, there's a good chance we can help. Book a discovery call and find out."
      />
    </>
  );
}
